import axios from 'axios'
import store from '@/store'
import _ from 'lodash'
const API_URL = process.env.API_URL
let refreshRequest = null
export default {
  getAccessToken () {
    return store.state.accessToken
  },
  getRefreshToken () {
    return store.state.refreshToken
  },
  getExpiration () {
    return store.state.expiration
  },
  getLoadingAccessToken () {
    return store.state.loadingAccessToken
  },
  getUser () {
    if (store.state.user) {
      return JSON.parse(store.state.user)
    }
    return null
  },
  getOrganization () {
    let user = this.getUser()
    if (user) {
      return user.personal.organization
    }
    return null
  },
  hasRoles (roles) {
    let has = false
    let user = this.getUser()
    if (user && user.personal) {
      let availableRoles = user.personal.roles
      _.forEach(availableRoles, availableRole => {
        _.forEach(roles, role => {
          if (role === availableRole.name) {
            has = true
          }
        })
      })
    }
    return has
  },
  getLanguage () {
    return store.state.language
  },
  setLanguage (language) {
    store.commit('SET_LANGUAGE', language)
    if (window.localStorage) {
      window.localStorage.setItem('language', language)
    }
  },
  getCurrencies () {
    return JSON.parse(store.state.currencies)
  },
  loadAccessToken () {
    if (this.getLoadingAccessToken()) {
      return refreshRequest
    }

    this.setAccessTokenLoading(true)
    refreshRequest = axios.post(API_URL + '/v1/auth/login/refresh', {
      'refresh_token': this.getRefreshToken()
    })

    return refreshRequest
  },
  setAccessTokenLoading (loading) {
    store.commit('SET_LOADING_ACCESS_TOKEN', loading)
  },
  formatExpirationDateTime (seconds) {
    let date = new Date()
    date.setSeconds(date.getSeconds() + seconds)
    return date
  },
  isAccessTokenExpired () {
    let expirationDateTime = new Date(this.getExpiration())
    return !this.getAccessToken() || expirationDateTime < new Date()
  },
  login (data) {
    let expiration = this.formatExpirationDateTime(data.expires_in)

    if (data.user) {
      store.commit('SET_USER', JSON.stringify(data.user))
      store.commit('SET_LANGUAGE', data.user.personal.language)
      store.commit('SET_CURRENCIES', data.user.personal.currencies)
    }
    store.commit('SET_ACCESS_TOKEN', data.access_token)
    store.commit('SET_REFRESH_TOKEN', data.refresh_token)
    store.commit('SET_EXPIRATION', expiration)

    if (window.localStorage) {
      if (data.user) {
        window.localStorage.setItem('user', JSON.stringify(data.user))
        window.localStorage.setItem('language', data.user.personal.language)
        window.localStorage.setItem('currencies', data.user.personal.currencies)
      }
      window.localStorage.setItem('accessToken', data.access_token)
      window.localStorage.setItem('refreshToken', data.refresh_token)
      window.localStorage.setItem('expiration', expiration)
    }
  },
  logout () {
    store.commit('SET_USER', null)
    store.commit('SET_ACCESS_TOKEN', null)
    store.commit('SET_REFRESH_TOKEN', null)
    store.commit('SET_EXPIRATION', null)

    if (window.localStorage) {
      window.localStorage.removeItem('user')
      window.localStorage.removeItem('accessToken')
      window.localStorage.removeItem('refreshToken')
      window.localStorage.removeItem('expiration')
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js